import React from "react";
import style from "./style.module.scss";
import moment from "moment/moment";
import { dateFormatter, formatCurrency } from "../../../../../../../../components/helper/helper";
import DollarSign24 from "../../../../../../../assets/svg/icons/common/DollarSign24";
import CheckMarkCircleGreen13 from "../../../../../../../assets/svg/icons/common/CheckMarkCircleGreen13";

function ChildTableRow({ data, lastRow }) {
  return (
    <tr className={`${style.line} ${!lastRow ? style.line_after : ""}`}>
      {/* <td className={style.child_table_cell}>
        <div className={style.align_center}>
          <DollarSign24 />
          {data?.card_type}
        </div>
      </td>
      <td className={style.child_table_cell}>
        <div className={style.align_center}>
          <CheckMarkCircleGreen13 />
          {data?.code}
        </div>
      </td> */}
      <td className={style.child_table_cell}>{data?.reference_number}</td>
      <td className={style.child_table_cell}>{data?.type}</td>
      <td className={style.child_table_cell}>{data.amount ? formatCurrency(data.amount) : '-'}</td>
      <td className={style.child_table_cell}>{dateFormatter(data?.date)}</td>
      <td className={style.child_table_cell}>{data?.transaction_description}</td>
      <td className={style.child_table_cell}>{'-'}</td>     
    </tr>
  );
}

export default ChildTableRow;
